import { useState, useEffect, forwardRef } from 'react';
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import PropTypes from 'prop-types';
import styledComponents from "styled-components";
import Countdown from 'react-countdown';

import {
    Autocomplete,
    Box,
    Divider,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Typography,
    TextField,
    Button,
    Menu,
    MenuItem,
    ListItemIcon,
    Modal,
    InputBase,
    InputLabel,
    IconButton,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Pagination,
    Select,
    Stack,
    Snackbar,
    Paper,
    FormControl,
    ListSubheader,
    LinearProgress
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';

import axios from  "axios";
import { Formik } from 'formik';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';

import jwtDecode from 'jwt-decode';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const verifyToken = (serviceToken) => {
    if (!serviceToken) {
        return false;
    }
    const decoded = jwtDecode(serviceToken);
    /**
     * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
     */
    return decoded.exp > Date.now() / 1000;
};


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Container = styledComponents.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: '70%' },
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4
};

const Completionist = () => <Button variant="outlined" disabled>APPROVE</Button>;

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a completed state
    return <Completionist />;
  } else {
    // Render a countdown
  return <span style={{ color: 'blue', fontWeight: 'bolder', fontSize: '11px' }}>{days} h : {hours} j : {minutes} m : {seconds} d</span>;
  }
};

const Dropship = ({ data, dataPo, updatedData }) => {

    const [token, setToken] = useState(
        JSON.parse(localStorage.getItem('token')) !== null ? 
            JSON.parse(localStorage.getItem('token')).token :
            null
    );
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();

    const [selectedCourier, setCourier] = useState(null);

    const [subdistricts, setSubdistricts] = useState([]);
    const [valueSubdistrict, setValueSubdistrict] = useState(subdistricts[0]);
    const [inputSdValue, setInputSdValue] = useState(null);
    const handleSelectSubdistrict = (e, val) => {
        setValueSubdistrict(val);
        setInputSdValue(val.subdistrict_id);
        if(selectedCourier !== null) {
          handleCourirChange(selectedCourier);
        }
    };
    

    const [cities, setCities] = useState([]);
    const [valueCity, setValueCity] = useState(cities[0]);
    const [inputCityValue, setInputCityValue] = useState(null);

    const handleSelectCity = async (e, val) => {
        setValueCity(val);
        setInputCityValue(val.city_id);
        try {
            const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/subdistrict/${val.city_id}`);
            setSubdistricts(getData.data.result);
        } catch (err) {
            console.log(err);
        }
    };

    const [provinces, setProvinces] = useState([]);
    const [valueProvince, setValueProvince] = useState(provinces[0]);
    const [inputProvValue, setInputProvValue] = useState('');

    const handleSelectProvince = async (e, val) => {
        setValueProvince(val);
        setInputProvValue(val.province_id);
        try {
            const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/city/${val.province_id}`);
            setCities(getData.data.result);
        } catch (err) {
            console.log(err);
        }
    };

    const [telPengirim, setTelPengirim] = useState(null);
    const [telPenerima, setTelPenerima] = useState(null);
    const changeTelpPengirim = (value) =>  {
        setTelPengirim(value);
    };
    const changeTelpPenerima = (value) =>  {
        setTelPenerima(value);
    };

    const [openEdit, setOpenEdit] = useState(false);
    const [openAdd, setOpenAdd] = useState(false);
    const handleCloseEdit = () => setOpenEdit(false);
    const handleCloseAdd = () => setOpenAdd(false);
    const handleOpenAdd = () => setOpenAdd(true);
    const handleOpenEdit = () => setOpenEdit(true);
    const [valToEdit, setValToEdit] = useState(null);

    const [shippingCost, setShippingCost] = useState({});
    const [shippingLoading, setShippingLoading] = useState(false);

    const handleCourirChange = async (courierValue) => {
        const courierCode = courierValue.split('|');
        if( courierCode[0] === 'OR' ) {
          try {
            const getShipping = await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/shipping/cost`,
              {
                origin: 23,
                destination: inputSdValue,
                weight: 100,
                courier: courierCode[1]
              },
              {
                headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                }
              }
            );
            setShippingCost(getShipping.data.result.rajaongkir.results[0]);
            setShippingLoading(false);
    
          } catch (err) {
            console.log(err)
          }
        } else {
          setShippingLoading(false);
          setShippingCost({});
        }
    };

    const [layananState, setLayanan] = useState(null);

    const [openAlert, setOpenAlert] = useState(false);
    const [alertStatus, setAlertStatus] = useState('success');
    const [alertMessage, setAlertMessage] = useState('');
    const handleClickAlert = () => {
        setOpenAlert(true);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    useEffect(() => {
        const getProvinces = async () => {
          try {
            const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/province`);
            setProvinces(getData.data.result);
          } catch (err) {
            console.log(err);
          }
        }
    
        if(!verifyToken(token)){
          localStorage.removeItem('token');
          navigate('/');
        } else getProvinces();
      }, [])

    return (
        <Container>
            <Snackbar
                open={openAlert}
                autoHideDuration={2500}
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                key={'top' + 'center'}
            >
                <Alert onClose={handleCloseAlert} severity={alertStatus} sx={{ width: '100%' }}>
                    {alertMessage}
                </Alert>
            </Snackbar>
            <Modal
                open={openAdd}
                onClose={handleCloseAdd}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle} style={{ maxHeight: '340px', overflowY: 'auto'}}>
                <Formik
                    initialValues={{
                        namapengirim: null,
                        tlppengirim: telPengirim,
                        namapenerima: null,
                        tlppenerima: telPenerima,
                        alamatpenerima: null,
                        provinsi: null,
                        kota: null,
                        kecamatan: null,
                        keterangan: null,
                        ekspedisi: null,
                        layanan: null
                    }}
                    validate={values => {
                        const errors = {};
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                        values.idpoproduk = searchParams.get('idpoproduk');
                        values.tlppengirim = telPengirim;
                        values.tlppenerima = telPenerima;
                        values.provinsi = inputProvValue;
                        values.kota = inputCityValue;
                        values.kecamatan = inputSdValue;
                        values.invoice = searchParams.get('invoice');
                        const ekspedisi = selectedCourier !== null
                            ? (
                                selectedCourier.split('|')[0] === 'OR'
                                    ? (`${selectedCourier.split('|')[1]} ${layananState.split('|')[0]}`).toUpperCase()
                                    : (`${selectedCourier.split('|')[1]}`).toUpperCase()
                            )
                            : null;
                        values.ekspedisi = ekspedisi;
                        
                        const filteredVal = Object.keys(values).reduce((newObj, key) => {
                            const value = values[key];
                            if (value !== null && key !== 'layanan') {
                                newObj[key] = value;
                            }
                            return newObj;
                        }, {});
                        console.log(filteredVal);
                        try {
                            await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/dropship/create`, filteredVal, {
                                headers: {
                                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                }
                            });
                            
                            // update states
                            const po = await axios.get(
                                `${process.env.REACT_APP_API_URL}/api/dashboard/dropship/list`, {
                                    params: {
                                        invoice: searchParams.get('invoice'),
                                        idpoproduk: searchParams.get('idpoproduk')
                                    },
                                    headers: {
                                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                    }
                                }
                            );
                            let no = 0;
                            updatedData(po.data.result.map((v) => ({ ...v, no: no += 1 })));
                            
                            setAlertStatus('success');
                            setAlertMessage('Tambah dropship berhasil');
                            setOpenAlert(true);
                            setOpenAdd(false);
                        } catch (err) {
                            console.log(err);
                            setSubmitting(false);
                        }
                    }}
                >
                    {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    /* and other goodies */
                    }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <Typography id="modal-modal-title" variant="subtitle1" fontWeight="700">
                                    Tambah Dropship
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Nama Pengirim
                                </InputLabel>
                                <TextField
                                    fullWidth
                                    required
                                    type="text"
                                    size="small"
                                    name="namapengirim"
                                    id="outlined-basic"
                                    variant="outlined"
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Telepon Pengirim
                                </InputLabel>
                                <PhoneInput
                                    required
                                    disableDropdown
                                    countryCodeEditable={false}
                                    name="tlppengirim"
                                    country={'id'}
                                    onlyCountries={['id']}
                                    value={telPengirim}
                                    inputStyle={{ width: '100%', height: '3em' }}
                                    onChange={changeTelpPengirim}
                                />

                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Nama Penerima
                                </InputLabel>
                                <TextField
                                    fullWidth
                                    required
                                    type="text"
                                    size="small"
                                    name="namapenerima"
                                    id="outlined-basic"
                                    variant="outlined"
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Telepon Penerima
                                </InputLabel>
                                <PhoneInput
                                    required
                                    disableDropdown
                                    countryCodeEditable={false}
                                    name="tlppenerima"
                                    country={'id'}
                                    onlyCountries={['id']}
                                    value={telPenerima}
                                    inputStyle={{ width: '100%', height: '3em' }}
                                    onChange={changeTelpPenerima}
                                />

                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Alamat
                                </InputLabel>
                                <TextField
                                    fullWidth
                                    required
                                    name="alamatpenerima"
                                    id="outlined-multiline-static"
                                    multiline
                                    rows={4}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Keterangan
                                </InputLabel>
                                <TextField
                                    fullWidth
                                    required
                                    name="keterangan"
                                    id="outlined-multiline-static"
                                    multiline
                                    rows={4}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Provinsi Tujuan
                                </InputLabel>
                                <Autocomplete
                                    required
                                    fullWidth
                                    size="small"
                                    value={valueProvince}
                                    onChange={handleSelectProvince}
                                    options={provinces}
                                    getOptionLabel={(option) => option.province_name}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            {option.province_name}
                                        </li>
                                    )}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>                            
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Kota/Kabupaten Tujuan
                                </InputLabel>
                                <Autocomplete
                                    required
                                    fullWidth
                                    disabled={cities.length === 0}
                                    size="small"
                                    value={valueCity}
                                    onChange={handleSelectCity}
                                    options={cities}
                                    getOptionLabel={(option) => option.city_name}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            {option.city_name}
                                        </li>
                                    )}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Kecamatan Tujuan
                                </InputLabel>
                                <Autocomplete
                                    required
                                    fullWidth
                                    disabled={subdistricts.length === 0}
                                    size="small"
                                    value={valueSubdistrict}
                                    onChange={handleSelectSubdistrict}
                                    options={subdistricts}
                                    getOptionLabel={(option) => option.subdistrict_name}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            {option.subdistrict_name}
                                        </li>
                                    )}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </Grid>
                            {inputProvValue !== null && inputCityValue !== null && inputSdValue !== null && (
                                <Grid item xs={12}>
                                    <FormControl sx={{ width: '100%' }}>
                                    <InputLabel
                                        id="demo-simple-select-helper-label"
                                        sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                        Kurir
                                    </InputLabel>
                                    <Select
                                        fullWidth
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        name="ekspedisi"
                                        label="Ekspedisi"
                                        onChange={(event) => {
                                            setCourier(event.target.value);
                                            setShippingLoading(true);
                                            handleCourirChange(event.target.value);
                                        }}
                                        required
                                    >
                                        <MenuItem value="OR|jne">JNE</MenuItem>
                                        <MenuItem value="OR|tiki">TIKI</MenuItem>
                                        <MenuItem value="OR|pos">POS INDONESIA</MenuItem>
                                        <MenuItem value="OR|wahana">WAHANA</MenuItem>
                                        <MenuItem value="OR|sicepat">SICEPAT</MenuItem>
                                        <MenuItem value='OR|jnt'>J&T</MenuItem>
                                        <MenuItem value='OR|lion'>LION</MenuItem>
                                        <MenuItem value='OR|anteraja'>Anteraja</MenuItem>
                                        <MenuItem value='OR|ide'>ID Express</MenuItem>
                                        {/* <optgroup label="Lainnya (Ongkir Manual)"> */}
                                        <ListSubheader><b>Kurir lainnya (ongkir manual)</b></ListSubheader>
                                        <MenuItem value='OM|idetruck'>&nbsp;&nbsp;ID Express Truck</MenuItem>
                                        <MenuItem value='OM|jntcargo'>&nbsp;&nbsp;J&T Cargo</MenuItem>
                                        <MenuItem value='OM|jtr'>&nbsp;&nbsp;JTR</MenuItem>
                                        <MenuItem value='OM|Ahsan'>&nbsp;&nbsp;Ahsan</MenuItem>
                                        <MenuItem value='OM|Baraka'>&nbsp;&nbsp;Baraka</MenuItem>
                                        <MenuItem value='OM|Dakota'>&nbsp;&nbsp;Dakota</MenuItem>
                                        <MenuItem value='OM|IndahCargo'>&nbsp;&nbsp;IndahCargo</MenuItem>
                                        <MenuItem value='OM|Adam Cargo'>&nbsp;&nbsp;Adam Cargo</MenuItem>
                                        <MenuItem value='OM|Pegasus'>&nbsp;&nbsp;Pegasus</MenuItem>
                                        <MenuItem value='OM|Gosend'>&nbsp;&nbsp;GoSend</MenuItem>
                                        <MenuItem value='OM|KALOG'>&nbsp;&nbsp;KALOG</MenuItem>
                                        <MenuItem value='OM|Sentral'>&nbsp;&nbsp;Sentral</MenuItem>
                                        <MenuItem value='OM|CMC KARGO'>&nbsp;&nbsp;CMC CARGO</MenuItem>
                                        <MenuItem value='OM|Triplogic'>&nbsp;&nbsp;Triplogic</MenuItem>
                                        <MenuItem value='OM|Ambil ke Pusat'>&nbsp;&nbsp;Ambil Ke Pusat</MenuItem>
                                        <MenuItem value='OM|Disatukan'>&nbsp;&nbsp;Disatukan Paket Lainnya</MenuItem>
                                    </Select>
                                    </FormControl>
                                </Grid>
                                )}
                                {shippingLoading && (
                                <Grid item xs={12} align="center">
                                    <Typography variant="body2">Loading ongkir ...</Typography>
                                    <LinearProgress />
                                </Grid>
                                )}
                                {shippingCost && Object.keys(shippingCost).length > 0 && (
                                <Grid item xs={12}>
                                    <FormControl sx={{ width: '100%' }}>
                                    <InputLabel
                                        id="demo-simple-select-helper-label"
                                        sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                        Layanan / Ongkir
                                    </InputLabel>
                                    <Select
                                        fullWidth
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        name="layanan"
                                        label="Layanan / ongkir"
                                        onChange={(event) => setLayanan(event.target.value)}
                                        required
                                    >
                                        {/* <MenuItem value="tes">tes</MenuItem> */}
                                        {shippingCost.costs.map((item) => (
                                        <MenuItem value={`${item.service}|${item.cost[0].value}`}>{`${item.service} | ${item.cost[0].value}`}</MenuItem>
                                        ))}
                                    </Select>
                                    </FormControl>
                                </Grid>
                                )}
                            <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                                <Button variant="contained" type="submit" disabled={isSubmitting}>Submit</Button>
                            </Grid>
                        </Grid>
                    </form>
                    )}
                </Formik>
                </Box>
            </Modal>
            <Modal
                open={openEdit}
                onClose={handleCloseEdit}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle} style={{ maxHeight: '340px', overflowY: 'auto'}}>
                <Formik
                    enableReinitialize
                    initialValues={{
                        namapengirim: null,
                        tlppengirim: telPengirim,
                        namapenerima: null,
                        tlppenerima: telPenerima,
                        alamatpenerima: null,
                        provinsi: inputProvValue,
                        kota: inputCityValue,
                        kecamatan: inputSdValue,
                        keterangan: null,
                        ekspedisi: selectedCourier,
                        layanan: layananState
                    }}
                    validate={values => {
                        const errors = {};
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {

                        const ekspedisi = values.ekspedisi !== null
                            ? (
                                values.ekspedisi.split('|')[0] === 'OR'
                                    ? (`${values.ekspedisi.split('|')[1]} ${values.layanan.split('|')[0]}`).toUpperCase()
                                    : (`${values.ekspedisi.split('|')[1]}`).toUpperCase()
                            )
                            : null;
                        values.ekspedisi = ekspedisi;
                        
                        const filteredVal = Object.keys(values).reduce((newObj, key) => {
                            const value = values[key];
                            if (value !== null && key !== 'layanan') {
                                newObj[key] = value;
                            }
                            return newObj;
                        }, {});
                        console.log(filteredVal);

                        try {
                            await axios.put(`${process.env.REACT_APP_API_URL}/api/dashboard/dropship/update/${valToEdit.iddropship}`, filteredVal, {
                                headers: {
                                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                }
                            });
                            
                            // update states
                            const po = await axios.get(
                                `${process.env.REACT_APP_API_URL}/api/dashboard/dropship/list`, {
                                    params: {
                                        invoice: searchParams.get('invoice'),
                                        idpoproduk: searchParams.get('idpoproduk')
                                    },
                                    headers: {
                                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                    }
                                }
                            );
                            let no = 0;
                            updatedData(po.data.result.map((v) => ({ ...v, no: no += 1 })));
                            
                            setAlertStatus('success');
                            setAlertMessage('Ubah dropship berhasil');
                            setOpenAlert(true);
                            setOpenEdit(false);
                            setValToEdit(null);
                            setTelPengirim(null);
                            setTelPenerima(null);
                        } catch (err) {
                            console.log(err);
                            setSubmitting(false);
                        }
                    }}
                >
                    {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    /* and other goodies */
                    }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <Typography id="modal-modal-title" variant="subtitle1" fontWeight="700">
                                    Ubah Dropship
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Nama Pengirim
                                </InputLabel>
                                <TextField
                                    fullWidth
                                    required
                                    type="text"
                                    size="small"
                                    name="namapengirim"
                                    id="outlined-basic"
                                    variant="outlined"
                                    defaultValue={valToEdit.namapengirim}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Telepon Pengirim
                                </InputLabel>
                                <PhoneInput
                                    disableDropdown
                                    countryCodeEditable={false}
                                    name="tlppengirim"
                                    country={'id'}
                                    onlyCountries={['id']}
                                    value={telPengirim}
                                    inputStyle={{ width: '100%', height: '3em' }}
                                    onChange={changeTelpPengirim}
                                />

                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Nama Penerima
                                </InputLabel>
                                <TextField
                                    fullWidth
                                    required
                                    type="text"
                                    size="small"
                                    name="namapenerima"
                                    id="outlined-basic"
                                    variant="outlined"
                                    onChange={handleChange}
                                    defaultValue={valToEdit.namapenerima}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Telepon Penerima
                                </InputLabel>
                                <PhoneInput
                                    disableDropdown
                                    countryCodeEditable={false}
                                    name="tlppenerima"
                                    country={'id'}
                                    onlyCountries={['id']}
                                    value={telPenerima}
                                    inputStyle={{ width: '100%', height: '3em' }}
                                    onChange={changeTelpPenerima}
                                />

                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Alamat
                                </InputLabel>
                                <TextField
                                    fullWidth
                                    required
                                    name="alamatpenerima"
                                    id="outlined-multiline-static"
                                    multiline
                                    rows={4}
                                    onChange={handleChange}
                                    defaultValue={valToEdit.alamatpenerima}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Keterangan
                                </InputLabel>
                                <TextField
                                    fullWidth
                                    required
                                    name="keterangan"
                                    id="outlined-multiline-static"
                                    multiline
                                    rows={4}
                                    onChange={handleChange}
                                    defaultValue={valToEdit.keterangan}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Provinsi Tujuan
                                </InputLabel>
                                <Autocomplete
                                    fullWidth
                                    size="small"
                                    value={valueProvince}
                                    onChange={handleSelectProvince}
                                    options={provinces}
                                    getOptionLabel={(option) => option.province_name}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            {option.province_name}
                                        </li>
                                    )}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>                            
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Kota/Kabupaten Tujuan
                                </InputLabel>
                                <Autocomplete
                                    fullWidth
                                    disabled={cities.length === 0}
                                    size="small"
                                    value={valueCity}
                                    onChange={handleSelectCity}
                                    options={cities}
                                    getOptionLabel={(option) => option.city_name}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            {option.city_name}
                                        </li>
                                    )}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                    Kecamatan Tujuan
                                </InputLabel>
                                <Autocomplete
                                    fullWidth
                                    disabled={subdistricts.length === 0}
                                    size="small"
                                    value={valueSubdistrict}
                                    onChange={handleSelectSubdistrict}
                                    options={subdistricts}
                                    getOptionLabel={(option) => option.subdistrict_name}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            {option.subdistrict_name}
                                        </li>
                                    )}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </Grid>
                            {inputProvValue !== null && inputCityValue !== null && inputSdValue !== null && (
                                <Grid item xs={12}>
                                    <FormControl sx={{ width: '100%' }}>
                                    <InputLabel
                                        id="demo-simple-select-helper-label"
                                        sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                        Kurir
                                    </InputLabel>
                                    <Select
                                        fullWidth
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        name="ekspedisi"
                                        label="Ekspedisi"
                                        onChange={(event) => {
                                            setCourier(event.target.value);
                                            setShippingLoading(true);
                                            handleCourirChange(event.target.value);
                                        }}
                                        required
                                    >
                                        <MenuItem value="OR|jne">JNE</MenuItem>
                                        <MenuItem value="OR|tiki">TIKI</MenuItem>
                                        <MenuItem value="OR|pos">POS INDONESIA</MenuItem>
                                        <MenuItem value="OR|wahana">WAHANA</MenuItem>
                                        <MenuItem value="OR|sicepat">SICEPAT</MenuItem>
                                        <MenuItem value='OR|jnt'>J&T</MenuItem>
                                        <MenuItem value='OR|lion'>LION</MenuItem>
                                        <MenuItem value='OR|anteraja'>Anteraja</MenuItem>
                                        <MenuItem value='OR|ide'>ID Express</MenuItem>
                                        {/* <optgroup label="Lainnya (Ongkir Manual)"> */}
                                        <ListSubheader><b>Kurir lainnya (ongkir manual)</b></ListSubheader>
                                        <MenuItem value='OM|idetruck'>&nbsp;&nbsp;ID Express Truck</MenuItem>
                                        <MenuItem value='OM|jntcargo'>&nbsp;&nbsp;J&T Cargo</MenuItem>
                                        <MenuItem value='OM|jtr'>&nbsp;&nbsp;JTR</MenuItem>
                                        <MenuItem value='OM|Ahsan'>&nbsp;&nbsp;Ahsan</MenuItem>
                                        <MenuItem value='OM|Baraka'>&nbsp;&nbsp;Baraka</MenuItem>
                                        <MenuItem value='OM|Dakota'>&nbsp;&nbsp;Dakota</MenuItem>
                                        <MenuItem value='OM|IndahCargo'>&nbsp;&nbsp;IndahCargo</MenuItem>
                                        <MenuItem value='OM|Adam Cargo'>&nbsp;&nbsp;Adam Cargo</MenuItem>
                                        <MenuItem value='OM|Pegasus'>&nbsp;&nbsp;Pegasus</MenuItem>
                                        <MenuItem value='OM|Gosend'>&nbsp;&nbsp;GoSend</MenuItem>
                                        <MenuItem value='OM|KALOG'>&nbsp;&nbsp;KALOG</MenuItem>
                                        <MenuItem value='OM|Sentral'>&nbsp;&nbsp;Sentral</MenuItem>
                                        <MenuItem value='OM|CMC KARGO'>&nbsp;&nbsp;CMC CARGO</MenuItem>
                                        <MenuItem value='OM|Triplogic'>&nbsp;&nbsp;Triplogic</MenuItem>
                                        <MenuItem value='OM|Ambil ke Pusat'>&nbsp;&nbsp;Ambil Ke Pusat</MenuItem>
                                        <MenuItem value='OM|Disatukan'>&nbsp;&nbsp;Disatukan Paket Lainnya</MenuItem>
                                    </Select>
                                    </FormControl>
                                </Grid>
                                )}
                                {shippingLoading && (
                                <Grid item xs={12} align="center">
                                    <Typography variant="body2">Loading ongkir ...</Typography>
                                    <LinearProgress />
                                </Grid>
                                )}
                                {shippingCost && Object.keys(shippingCost).length > 0 && (
                                <Grid item xs={12}>
                                    <FormControl sx={{ width: '100%' }}>
                                    <InputLabel
                                        id="demo-simple-select-helper-label"
                                        sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                        Layanan / Ongkir
                                    </InputLabel>
                                    <Select
                                        fullWidth
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        name="layanan"
                                        label="Layanan / ongkir"
                                        onChange={(event) => setLayanan(event.target.value)}
                                        required
                                    >
                                        {/* <MenuItem value="tes">tes</MenuItem> */}
                                        {shippingCost.costs.map((item) => (
                                        <MenuItem value={`${item.service}|${item.cost[0].value}`}>{`${item.service} | ${item.cost[0].value}`}</MenuItem>
                                        ))}
                                    </Select>
                                    </FormControl>
                                </Grid>
                                )}
                            <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                                <Button variant="contained" type="submit" disabled={isSubmitting}>Submit</Button>
                            </Grid>
                        </Grid>
                    </form>
                    )}
                </Formik>
                </Box>
            </Modal>
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{ margin: '10px 14px'}}>
                    <Typography variant="h6" fontWeight="700">DROPSHIP {dataPo !== null && dataPo.namapo}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Button variant="contained" onClick={handleOpenAdd}>
                        <AddCircleIcon />&nbsp;
                        Tambah Dropship
                    </Button>
                </Grid>
                <Grid item xs={12} sx={{ paddingY: '22px' }}>
                    <TableContainer component={Paper} sx={{ maxHeight: {xs: '70vh', sm: 740, md: 800} }}>
                        <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 540 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell><Typography variant="subtitle2" fontWeight="700">No</Typography></TableCell>
                                    <TableCell><Typography variant="subtitle2" fontWeight="700">Opsi</Typography></TableCell>
                                    <TableCell><Typography variant="subtitle2" fontWeight="700">Status Kirim</Typography></TableCell>
                                    <TableCell><Typography variant="subtitle2" fontWeight="700">Invoice</Typography></TableCell>
                                    <TableCell><Typography variant="subtitle2" fontWeight="700">Nama Pengirim</Typography></TableCell>
                                    <TableCell><Typography variant="subtitle2" fontWeight="700">Telepon Pengirim</Typography></TableCell>
                                    <TableCell><Typography variant="subtitle2" fontWeight="700">Nama Penerima</Typography></TableCell>
                                    <TableCell><Typography variant="subtitle2" fontWeight="700">Telepon Penerima</Typography></TableCell>
                                    <TableCell><Typography variant="subtitle2" fontWeight="700">Alamat Penerima</Typography></TableCell>
                                    <TableCell><Typography variant="subtitle2" fontWeight="700">Keterangan</Typography></TableCell>
                                    <TableCell><Typography variant="subtitle2" fontWeight="700">Ekspedisi</Typography></TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((row) => (
                                    <TableRow>
                                        <TableCell><Typography variant="subtitle2">{row.no}</Typography></TableCell>
                                        <TableCell>
                                            <Button
                                                variant="outlined"
                                                onClick={() => {
                                                    handleOpenEdit();
                                                    setValToEdit(row);
                                                    setTelPengirim(row.tlppengirim);
                                                    setTelPenerima(row.tlppenerima);
                                                }}
                                            >
                                                Ubah
                                            </Button>
                                        </TableCell>
                                        <TableCell><Typography variant="subtitle2">{row.statuskirim}</Typography></TableCell>
                                        <TableCell><Typography variant="subtitle2">{row.invoice}</Typography></TableCell>
                                        <TableCell><Typography variant="subtitle2">{row.namapengirim}</Typography></TableCell>
                                        <TableCell><Typography variant="subtitle2">{row.tlppengirim}</Typography></TableCell>
                                        <TableCell><Typography variant="subtitle2">{row.namapenerima}</Typography></TableCell>
                                        <TableCell><Typography variant="subtitle2">{row.tlppenerima}</Typography></TableCell>
                                        <TableCell><Typography variant="subtitle2">{row.alamatpenerima}</Typography></TableCell>
                                        <TableCell><Typography variant="subtitle2">{row.keterangan}</Typography></TableCell>
                                        <TableCell><Typography variant="subtitle2">{row.ekspedisi}</Typography></TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Container>
    )
}

export default Dropship
